var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockOpenStreamlineSharpMaterialSymbols({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    id: "Lock-Open--Streamline-Sharp-Material",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Lock Open Streamline Icon: https://streamlinehq.com\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 44V16.3h22.5v-4.8c0 -1.80567 -0.6313 -3.34033 -1.894 -4.604C27.3433 5.632 25.81 5 24.006 5c-1.804 0 -3.3393 0.632 -4.606 1.896 -1.2667 1.26367 -1.9 2.79833 -1.9 4.604h-3c0 -2.63333 0.9268 -4.875 2.7805 -6.725C19.1338 2.925 21.3755 2 24.0055 2c2.6297 0 4.8695 0.92633 6.7195 2.779C32.575 6.63133 33.5 8.87167 33.5 11.5v4.8H40V44H8Zm3 -3h26V19.3H11V41Zm13.0085 -7c1.061 0 1.9665 -0.3672 2.7165 -1.1015s1.125 -1.6172 1.125 -2.6485c0 -1 -0.3778 -1.9083 -1.1335 -2.725 -0.7557 -0.8167 -1.664 -1.225 -2.725 -1.225 -1.061 0 -1.9665 0.4083 -2.7165 1.225 -0.75 0.8167 -1.125 1.7333 -1.125 2.75s0.3778 1.8917 1.1335 2.625c0.7557 0.7333 1.664 1.1 2.725 1.1Z",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpenStreamlineSharpMaterialSymbols);
export default __webpack_public_path__ + "static/media/Lock-Open--Streamline-Sharp-Material-Symbols.9dd9ad88c4d6fbbb192dfb97e85d9f87.svg";
export { ForwardRef as ReactComponent };